export function SanitezeHostUrl(value) {
  value = value.toLowerCase();
  value = value.replace("https://", "");
  value = value.replace("www", "");
  value = value.split('.').join('');
  value = value.split(',').join('');
  value = value.split(';').join('');
  value = value.split('/').join('');
  value = value.replace(/ /g, '-');
  value = value.replace(/  /g, '-');
  return value;
}